import React from 'react';
import DocumentsTable from '../../components/documentsTable/documentsTable';
import Main from '../../../layout/main/main';
import useTranslate from '../../../../common/hooks/useTranslate';

const Documents: React.FC = () => {
  const { t } = useTranslate();
  return (
    <Main title={t('DOCUMENTS.PAGE_TITLE')} subtitle={t('DOCUMENTS.PAGE_SUBTITLE')}>
      <DocumentsTable />
    </Main>
  );
};

export default Documents;
